<s1-input-label [label]="label">
  <input #input class="form-control {{  customClass }}" [ngClass]="{'is-invalid' : !checkIsValid() }" type="{{ type }}" [formControl]="control" [(colorPicker)]="color" [style.background]="color" [readonly]="readonly"/>
</s1-input-label>